import { emojiCursor } from '../../../utils/emoji-cursor';
import { getApiForNodeType } from '../../common/api/api-map';
import { BaseApi } from '../../common/api/base-api.interface';
import { EmojiNodeCreateProps } from '../models/emoji-node-create-props';
import { createEmojiNode } from './create-emoji-node';
import { setupEmojiNode } from './setup-emoji-node';

export const emojiNodeAPI = (): BaseApi<EmojiNodeCreateProps> => ({
  name: 'emojiNode',
  setup: setupEmojiNode,
  create: createEmojiNode,
  getCursor: (emoji: string) => emojiCursor(emoji),
  ...getApiForNodeType('emojiNode'),
});
